const map = {
	"./App Drawer.svg": 89734,
	"./Get help.svg": 92791,
	"./Menu.svg": 55503,
	"./Navigation.svg": 75672,
	"./Report scheduler.svg": 68559,
	"./Themes.svg": 86576,
	"./User mgmt.svg": 7750,
	"./dashboard.svg": 79646,
	"./dashboard_new.svg": 96853,
	"./filter.svg": 79500,
	"./grants.svg": 6083,
	"./homeIcon.svg": 20904,
	"./mei.svg": 89857,
	"./sip.svg": 4694,
	"./support_ticket.svg": 72090,
	"./sustainability.svg": 58573,
	"./volunteer.svg": 74968,
	"./workflow.svg": 98737
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51529;